import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";

import ErrorMessage from "./errormessage";
import Form from "./form";
import Input from "./input";
import P from "./p";
import Page from "./page";
import PageHeader from "./pageheader";
import Textarea from "./textarea";
import { Loader } from "../shared";

function CommunityForm({ application, mediaQuery, person }) {
  const isCIR = person !== undefined ? person.membership_type === 'Creative in Residence' : false;
  const nextUrl = isCIR ? "/apply/review/" : "/apply/open-house/";
  const submitUrl = "/api/applications/v4/application/community/";
  const {
    submission: { community = {
      nom_1_first_name: '',
      nom_1_last_name: '',
      nom_1_reason: '',
      nom_2_first_name: '',
      nom_2_last_name: '',
      nom_2_reason: ''
    }
    }
  } = application;
  const [form, setForm] = useState({
    errors: {},
    ...community
  });
  return (
    <Form form={form} setForm={setForm} nextUrl={nextUrl} showBack={true} submitUrl={submitUrl}>
      <div style={{ margin: "1rem" }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1rem", marginBottom: "1rem" }}>
          <div>
            <p>Nomination 1</p>
            <Input
              type="text"
              name="nom_1_first_name"
              value={form?.nom_1_first_name || ""}
              maxLength="256"
              placeholder="First name"
              form={form}
              setForm={setForm}
              style={{ gridColumn: mediaQuery.isTabletOrMobile ? "span 2" : "", marginBottom: "1rem" }}
              required={false}
            />
            <Input
              type="text"
              name="nom_1_last_name"
              value={form?.nom_1_last_name || ""}
              maxLength="256"
              placeholder="Last name"
              form={form}
              setForm={setForm}
              style={{ gridColumn: mediaQuery.isTabletOrMobile ? "span 2" : "", marginBottom: "1rem" }}
              required={false}
            />
            <Input
              type="email"
              name="nom_1_email"
              value={form?.nom_1_email || ""}
              maxLength="255"
              placeholder="Email address"
              form={form}
              setForm={setForm}
              style={{ gridColumn: mediaQuery.isTabletOrMobile ? "span 2" : "" }}
            />
            <Textarea
              form={form}
              value={form?.nom_1_reason || ""}
              name="nom_1_reason"
              placeholder="Reason you'd nominate"
              required={false}
              setForm={setForm}
            />
          </div>
          <div>
            <p>Nomination 2</p>
            <Input
              type="text"
              name="nom_2_first_name"
              value={form?.nom_2_first_name || ""}
              maxLength="256"
              placeholder="First name"
              form={form}
              setForm={setForm}
              style={{ gridColumn: mediaQuery.isTabletOrMobile ? "span 2" : "", marginBottom: "1rem" }}
              required={false}
            />
            <Input
              type="text"
              name="nom_2_last_name"
              value={form?.nom_2_last_name || ""}
              maxLength="256"
              placeholder="Last name"
              form={form}
              setForm={setForm}
              style={{ gridColumn: mediaQuery.isTabletOrMobile ? "span 2" : "", marginBottom: "1rem" }}
              required={false}
            />
            <Input
              type="email"
              name="nom_2_email"
              value={form?.nom_2_email || ""}
              maxLength="255"
              placeholder="Email address"
              form={form}
              setForm={setForm}
              style={{ gridColumn: mediaQuery.isTabletOrMobile ? "span 2" : "" }}
            />
            <Textarea
              form={form}
              value={form?.nom_2_reason || ""}
              name="nom_2_reason"
              placeholder="Reason you'd nominate"
              required={false}
              setForm={setForm}
            />
          </div>
        </div>
      </div>
    </Form>
  );
}

export default function CommunityPage({ mediaQuery, page, total, person }) {
  const { isLoading, error, data } = useQuery(["application"]);
  const {
    results: [application]
  } = data;
  return (
    <Page>
      <PageHeader title={`APPLICATION PAGE ${page} OF ${total}`} tagline="Building Community">
        <P style={{ marginBottom: "1rem" }}>
          The Battery membership is curated by its Members. Each member thoughtfully considers and nominates individuals who they believe will enhance The Battery's community.
        </P>
        <P style={{ marginBottom: "1rem" }}>
          We'd love to know who you believe will contribute positively to our community. The reasons for your nominations are as important as the individuals themselves and reflect your understanding of what The Battery community embodies.
        </P>
        <P>
          If your Membership is accepted, you will have an opportunity to nominate them without deducting from your 2 nomination allowance.
        </P>
      </PageHeader>
      {isLoading || application === undefined ? (
        <Loader loading={isLoading} />
      ) : (
        <CommunityForm application={application} mediaQuery={mediaQuery} person={person} />
      )}
      {error ? <ErrorMessage error={error} /> : null}
    </Page>
  );
}
